import OrgPicker from "@/components/OrgPicker";
import popReport from "@/pages/assetManagement/common/popReport";
import popRevoke from "@/pages/assetManagement/common/popRevoke";
import popCancel from "@/pages/assetManagement/common/popCancel";
import popDelete from "@/pages/assetManagement/common/popDelete";
import popRemark from "@/pages/assetManagement/common/popRemark";
export default {
  components: {
    OrgPicker, popReport, popRevoke, popCancel, popDelete, popRemark
  },
  data() {
    return {
      reportList: []
    }
  },
  methods: {
    // 模糊搜索员工
    userSearch(queryString, cb) {
       // 防抖优化
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.$api.userSearch(queryString).then(res => {
          if (res.code === 0) {
            let userList = res.data
            userList.forEach((item) => {
                item.value = item.name
            })
            let results = queryString ? userList : [];
            cb(results);
          } else {
            cb([]);
          }
        });
      }, 500);
    },
    userSelect(item) {
      this.form.ownerUserName = item.name
    },
    // 删除
    setDelete() {
      const params = {
        id: this.selectIds[0]
      }
      console.log('>>', params)
      this.btnDelete = true
      this.$api.workEmailDelete(params).then(res => {
        if (res.code == 0) {
          const routeName = this.$route.name
          if (routeName.includes('List')) {
            this.fetchData()
          }else if (routeName.includes('Detail')) {
            this.onBack()
          }
        }
      }).finally(() => {
        this.btnDelete = false
      })
    },
    // 注销
    setCancel(reason) {
      const params = {
        id: this.selectIds[0],
        reason
      }
      console.log('>>', params)
      this.btnCancel = true
      this.$api.workEmailCancel(params).then(res => {
        if (res.code == 0) {
          this.fetchData()
        }
      }).finally(() => {
        this.btnCancel = false
      })
    },
    // 撤销
    setRevoke() {
      const propertyId = this.selectIds[0]
      this.btnRevoke = true
      // 通过ID获取流程ID
      this.$api.getProcessId({propertyId}).then(res=>{
        if (res.code == 0 && res.data) {
          // console.log('>>',res.data)
          const processInstanceId = res.data
          // 发起撤销
          this.$api.workflowRevoke({processInstanceId}).then((res) => {
            if (res.code == 0) {
              this.$message.success("撤销成功");
              this.fetchData()
            }
          }).finally(()=>{
            this.btnRevoke = false
          })
        }
      })
    },
    // 转移人设置
    selected(data) {
      const params = {
        userId: data.id,
        remarks: data.remarks,
      }
      if (this.selectIds && this.selectIds.length > 0) {
        params.ids = this.selectIds
      } else if (this.form.ids && this.form.ids.length > 0) {
        params.ids = this.form.ids
      }
      this.btnTransfer = true
      this.reportList = []
      this.$refs.popReport.show('workEmail')
      console.log('>>', params)
      this.$api.workEmailTransfer(params).then(res=>{
        if(res.code ==0){
            this.reportList = res.data
            this.fetchData()
        }
      }).finally(() => {
        this.btnTransfer = false
      })
      

    },
    //获取字典数据
    getDictionaries(type) {
      if (type && this.dictionaries[type].length > 0) {
        return
      }
      const params = { groupId: type }
      this.$api.dictionaries(params).then(res => {
        this.dictionaries[type] = res.data || []
      }).catch((err) => {
        console.log(err)
      })
    },
  }
}
